import React, { Component } from 'react'
import { APIURL } from '../../config/config'
import axios from 'axios'
import { AlertSuccess } from '../Alert/Alert'
import Switch from 'react-switch'
import Swal from 'sweetalert2'
import {connect} from "react-redux";

class UnitsSetting extends Component{
  constructor (props) {
    super(props);

    this.state = {
      actionType: "บันทึก",
      units_list: [],
      unit_id: '',
      unit_name: '',
    }

    this.loadUnitsData = this.loadUnitsData.bind(this);
    this.saveUnits = this.saveUnits.bind(this);
    this.setEditForm = this.setEditForm.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.onChangeSwitch = this.onChangeSwitch.bind(this);
    this.deleteUnits = this.deleteUnits.bind(this);
  }

  loadUnitsData () {
    axios.get(APIURL + '/units')
        .then(res => {
          this.setState({units_list: res.data})
        }).catch(error => {
      this.setState({units_list: []})
    })
  }

  deleteUnits(units){
    let unit_id = units.unit_id
    let unit_name = units.unit_name

    let data = {
      unit_id: unit_id,
      status_field: 'delete'
    }

    Swal.fire({
      title: 'ยืนยันการลบ '+unit_name+' ?',
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        let url = APIURL+'/units/status'
        axios.post(url, data).then(res => {
          if(res.data === 'success') {
            AlertSuccess('ลบข้อมูลแล้ว')
            this.loadUnitsData()
          }
        })
      }
    });

  }

  saveUnits() {
    //let username = this.state.user.user
    let actionType = this.state.actionType
    let unit_name = this.state.unit_name

    let data= {
      unit_name,
    }

    if(actionType === "บันทึก") {
      let url = APIURL+'/units'
      axios.post(url, data).then(res => {
        if(res.data === 'success') {
          AlertSuccess('บันทึกข้อมูลแล้ว')
          this.clearForm()
          this.loadUnitsData()
        }
      })
    } else if (actionType === "แก้ไข") {
      let unit_id = this.state.unit_id
      data = {...data, unit_id: unit_id }
      let url = APIURL+'/units/'+unit_id
      axios.put(url, data).then(res => {
        if(res.data === 'success') {
          AlertSuccess('แก้ไขข้อมูลแล้ว')
          this.clearForm()
          this.loadUnitsData()
        }
      })
    }
  }

  setEditForm(units) {
    this.setState({
      actionType: 'แก้ไข',
      unit_name: units.unit_name,
      unit_id: units.unit_id,
    })
  }

  clearForm() {
    this.setState({
      actionType: "บันทึก",
      unit_name: '',
      unit_id: '',
    })
  }

  onChangeSwitch(checked, units){
    //let username = this.props.username
    let item_update = units
    let unit = this.state.units_list
    let item_index = this.state.units_list.findIndex(data => data.unit_id=== units.unit_id)

    if(checked === false){
      item_update.status_field = 'hidden'
    } else {
      item_update.status_field = 'show'
    }

    let data = {
      unit_id: item_update.unit_id,
      status_field: item_update.status_field
      //username: username
    }

    let url = APIURL+'/units/status'
      axios.post(url, data).then(res => {
    })

    unit[item_index] = item_update
    this.setState({
      units_list: unit
    })
  }

  /*componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    });
  }*/

  componentDidMount () {
    this.loadUnitsData()
  }

  render () {

    return (
      <div className="row">
        <div className="col-sm-7">
          <div className="card card-accent-info">
            <div className="card-header">
              <strong className="text-title">
                หน่วยสินค้า
              </strong>
            </div>
            <div className="mr-5 mt-3 text-right"><span className="text-danger">กดปิดการใช้งาน หากไม่ต้องการแสดงรายการ</span></div>

            <div className="card-block" style={styles.overflowY}>
              <table className="table table-striped table-responsive">
                <thead>
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center text-nowrap">ชื่อหน่วย</th>
                  <th className="text-center">ใช้งาน</th>
                  <th className="text-center">จัดการ</th>
                </tr>
                </thead>
                <tbody>
                {
                  this.state.units_list.map((unit, index) => (
                    <tr key={index}>
                      <td className="text-center" style={{width: 10}}>{ index+1 }</td>
                      <td className="text-center text-nowrap" style={{width: 80}}>{ unit.unit_name }</td>
                      <td className="text-nowrap text-center" style={{width: 80}}>

                        { unit.status_field === 'show' ? 'ใช้งาน' : 'ไม่ใช้งาน' }

                        <br/>

                        <Switch height = {20} width ={48}
                                onChange={(checked) => this.onChangeSwitch(checked, unit)}
                                checked={unit.status_field === 'show'}
                        />

                      </td>
                      <td className="text-center" style={{width: 120}}>
                        <button type="button"
                                className="btn btn-sm btn-warning btn-md-width mr-2 mb-2"
                                onClick={() => this.setEditForm(unit)}
                        >
                          <i className="fa fa-edit"/> แก้ไข
                        </button>
                              {/*<button type="button"
                                      className="btn btn-sm btn-danger btn-md-width mr-2 mb-2"
                                      onClick={() => this.deleteInsuranceCompany(insurance_company)}
                              >
                                <i className="fa fa-remove"/> ลบ
                              </button>*/}
                      </td>
                    </tr>
                  ))
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-sm-5">
          <div className="card card-accent-success">
            <div className="card-header card-customer">
              <strong className="text-title">เพิ่ม/แก้ไขชื่อหน่วยสินค้า</strong>
            </div>

            <div className="card-block">
              <div className="form-group">
                <label htmlFor="unit_name">ชื่อหน่วยสินค้า</label>
                <input
                  value={this.state.unit_name}
                  type="text"
                  className="form-control"
                  name="unit_name"
                  placeholder=""
                  style={styles.inputSearch}
                  onChange={(e) => {
                    this.setState({
                      unit_name: e.target.value
                    })
                  }}
                />
              </div>
            </div>

            <div className="card-footer text-right">
              <button type="button"
                      className="btn btn-sm btn-danger mr-2"
                      style={styles.button}
                      onClick={()=> this.clearForm()}
              >
                <i className="fa fa-refresh"/> ยกเลิก
              </button>

              <button type="button"
                      className={this.state.actionType==="แก้ไข"?  "btn btn-sm btn-warning" : "btn btn-sm btn-primary"}
                      style={styles.button}
                      onClick={() => {
                        this.saveUnits()
                      }}
              >
                <i className={this.state.actionType === "แก้ไข" ? "fa fa-edit" : "fa fa-save"}/> {this.state.actionType}
              </button>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})


const styles = {
  button: {
    borderRadius:5,
    height: 36,
  },
  inputSearch: {
    borderRadius:5,
  },
  overflowY: {
    overflow: 'scroll',
  }
}

export default connect(mapStateToProps)(UnitsSetting)
